module.exports = "/images/Sub-What we do-03.jpg";